import { VIEWS_MODULE_NAMESPACE } from '@/constants/modules';

const VIEW_MODEL = Object.freeze({
  companyAdmin: {
    employees: `${VIEWS_MODULE_NAMESPACE}/CompanyAdminModule/EmployeesModule`,
  },
  profiles: {
    business: {
      costAllocation: `${VIEWS_MODULE_NAMESPACE}/Profiles/Business/CostAllocation`,
    },
  },
});

export default VIEW_MODEL;
